import React from "react";
import { Container, Row, Col, Card, Badge, Button } from "react-bootstrap";
import { CheckCircleFill } from "react-bootstrap-icons";
import "./customapplication.scss";
import PageHero from '../Components/PageHero'

function CustomApplication() {
  return (
    <>
    <PageHero
     title="Custom Application Development"
     subtitle="Build software tailored to your needs"
    />

    <section className="custom-app-section py-5">
      <Container>

        {/* Header Section */}
        <div className="text-center mb-5">
          <Badge bg="primary" className="px-3 py-2 mb-3">
            Enterprise Software Solutions
          </Badge>

          <h2 className="fw-bold display-6">
            Custom Application Development Services
          </h2>

          <p className="text-muted">
            We build scalable, secure, and performance-driven custom software
            applications tailored to your unique business processes and goals.
          </p>
        </div>

        <Row className="g-4">

          {/* ERP Solutions */}
          <Col md={4}>
            <Card className="app-card h-100 shadow-lg border-0">
              <Card.Body>
                <h4 className="fw-bold border-bottom border-2 pb-2">ERP Solutions</h4>
                <p className="text-muted">
                  Integrated Enterprise Resource Planning systems to streamline
                  operations, finance, HR, and inventory management.
                </p>

                <ul className="feature-list">
                  <li><CheckCircleFill className="icon" /> Finance & Accounting</li>
                  <li><CheckCircleFill className="icon" /> Inventory Control</li>
                  <li><CheckCircleFill className="icon" /> HR & Payroll</li>
                  <li><CheckCircleFill className="icon" /> Reporting & Analytics</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>

          {/* CRM Solutions */}
          <Col md={4}>
            <Card className="app-card h-100 shadow-lg border-0">
              <Card.Body>
                <h4 className="fw-bold border-bottom border-2 pb-2">CRM Solutions</h4>
                <p className="text-muted">
                  Customer Relationship Management systems designed to improve
                  sales, marketing, and customer engagement processes.
                </p>

                <ul className="feature-list">
                  <li><CheckCircleFill className="icon" /> Lead Management</li>
                  <li><CheckCircleFill className="icon" /> Sales Automation</li>
                  <li><CheckCircleFill className="icon" /> Customer Tracking</li>
                  <li><CheckCircleFill className="icon" /> Performance Insights</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>

          {/* Custom Business Software */}
          <Col md={4}>
            <Card className="app-card h-100 shadow-lg border-0">
              <Card.Body>
                <h4 className="fw-bold border-bottom border-2 pb-2">Custom Business Applications</h4>
                <p className="text-muted">
                  Fully customized software solutions developed according to
                  your workflow and industry requirements.
                </p>

                <ul className="feature-list">
                  <li><CheckCircleFill className="icon" /> Web & Cloud Applications</li>
                  <li><CheckCircleFill className="icon" /> API Integration</li>
                  <li><CheckCircleFill className="icon" /> Secure Database Systems</li>
                  <li><CheckCircleFill className="icon" /> Role-Based Access</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>

        </Row>

        {/* Advantages Section */}
        <div className="mt-5 text-center">
          <h3 className="fw-bold mb-3">Advantages of Custom Applications</h3>

          <p className="text-muted col-lg-8 mx-auto">
            Custom applications are built specifically for your business model,
            offering better flexibility, security, and long-term scalability
            compared to generic software solutions.
          </p>

          <Row className="mt-4 g-4">

            <Col md={3}>
              <Card className="border-0 shadow-sm p-3">
                <h5 className="border-bottom border-1 pb-2">Scalability</h5>
                <p className="text-muted">
                  Easily expandable as your business grows.
                </p>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="border-0 shadow-sm p-3">
                <h5 className="border-bottom border-1 pb-2">Security</h5>
                <p className="text-muted">
                  Advanced security protocols and data protection.
                </p>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="border-0 shadow-sm p-3">
                <h5 className="border-bottom border-1 pb-2">Automation</h5>
                <p className="text-muted">
                  Reduces manual work and increases productivity.
                </p>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="border-0 shadow-sm p-3">
                <h5 className="border-bottom border-1 pb-2">Integration</h5>
                <p className="text-muted">
                  Seamless integration with existing systems.
                </p>
              </Card>
            </Col>

          </Row>

          <div className="mt-5">
            <Button variant="primary" size="lg" className="px-4">
              Request Project Consultation
            </Button>
          </div>
        </div>

      </Container>
    </section>
    </>
  );
}

export default CustomApplication;